module.exports = __webpack_public_path__ + "media/images/vp/icon.in.red-bcc9b82092041dba56d80abee0269bda.png";